// Pricing / options region of the product editor. A product is either priced
// directly (simple product → one tiered rule) or carries selectable options that
// each price themselves. The "has options" switch flips between the two. All
// state lives in the productEditor slice; OptionsEditor is keyed by the saved
// product id, so it prompts to save first for a brand-new product.
import { useDispatch, useSelector } from 'react-redux';
import {
  Box, Typography, Divider, FormControlLabel, Switch, TextField, MenuItem,
} from '@mui/material';
import {
  setHasOptions, setDraftField, setTiers, setStrategy, setFlatAmount,
} from '../../../store/product-editor-slice.js';
import PricingStrategySection from '../PricingStrategySection.jsx';
import OptionsEditor from '../OptionsEditor.jsx';

const ProductOptionsSection = () => {
  const dispatch = useDispatch();
  const {
    draft, tiers, strategy, flatAmount, hasOptions, productId,
  } = useSelector((state) => state.productEditor);

  return (
    <>
      <Divider />
      <FormControlLabel
        control={(
          <Switch
            checked={hasOptions}
            onChange={(e) => dispatch(setHasOptions(e.target.checked))}
          />
        )}
        label="This product has selectable options"
      />

      {hasOptions ? (
        <>
          <TextField
            label="Option selection"
            select
            value={draft.selection_mode}
            onChange={(e) => dispatch(setDraftField({ field: 'selection_mode', value: e.target.value }))}
            helperText="Single = pick one (radio); Multiple = pick many (checkboxes)."
          >
            <MenuItem value="single">Single</MenuItem>
            <MenuItem value="multiple">Multiple</MenuItem>
          </TextField>
          <Box>
            <Typography component="span" variant="subtitle2" sx={{ display: 'block', mb: 1 }}>
              Options
            </Typography>
            <OptionsEditor productId={productId} />
          </Box>
        </>
      ) : (
        <PricingStrategySection
          strategy={strategy}
          onStrategyChange={(next) => dispatch(setStrategy(next))}
          tiers={tiers}
          onTiersChange={(next) => dispatch(setTiers(next))}
          flatAmount={flatAmount}
          onFlatAmountChange={(next) => dispatch(setFlatAmount(next))}
        />
      )}
    </>
  );
};

export default ProductOptionsSection;
